import {PageContainer} from '@vidazoo/ui-kit';
import ChartsList from '../components/ChartsList';
import ChartsHeader from '../components/ChartsHeader';
import {ChartsListWithContext} from '../context/ChartsListContext';
import theme from './theme.module.scss';

export default function Charts() {
    return <ChartsListWithContext>
        <PageContainer pageTitle="Charts" top={1.2} className={theme.page}>
            <ChartsHeader/>
            <ChartsList/>
        </PageContainer>
    </ChartsListWithContext>;
}
